export class YearOfPassing {
    id:number;
    yearOfPass :string;
    monthId:number;
    }